import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { entityProfileTypeLabels } from "@components/entity/constants";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ChartOfAccountsTemplateRow } from "../chartOfAccountsTemplatesViewConfig";

export const ChartOfAccountsTemplateEntityTypeCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ChartOfAccountsTemplateRow, unknown>) => (
        <ViewTableCell>
            <span>{entityProfileTypeLabels[row.original.entityLegalType]}</span>
        </ViewTableCell>
    ),
);
